import type { DeliveryPricing } from './types'

export const formatPrice = (price?: string | null, fallback = '£--') => {
  if (!price) {
    return fallback
  }

  const priceValue = Number(price)

  return Number.isNaN(priceValue) ? `£${price}` : `£${priceValue.toFixed(2)}`
}

const isPositivePrice = (price?: string | null) => Number(price || 0) > 0

const isNonZeroPrice = (price?: string | null) => Number(price || 0) !== 0

const formatSurchargePrice = (price?: string | null) => {
  const surchargeValue = Number(price)

  if (Number.isNaN(surchargeValue)) {
    return formatPrice(price)
  }

  return surchargeValue < 0 ? `-£${Math.abs(surchargeValue).toFixed(2)}` : formatPrice(price)
}

const formatDiscountLabel = (percentageOff?: string | null) => {
  const discountPercentage = Number(percentageOff)

  return discountPercentage > 0 ? `Discount (-${discountPercentage.toFixed(0)}%)` : 'Discount'
}

export const getDiscount = (pricing: DeliveryPricing) => {
  if (isPositivePrice(pricing.totalDiscount)) {
    return {
      label: formatDiscountLabel(pricing.percentageOff),
      total: formatPrice(pricing.totalDiscount),
    }
  }

  return null
}

export const getProductTotal = (pricing: DeliveryPricing) => {
  if (!isPositivePrice(pricing.productTotal)) {
    return null
  }

  return formatPrice(pricing.productTotal)
}

export const getSurchargeTotal = (pricing: DeliveryPricing) => {
  if ((pricing.surchargeCount || 0) <= 0 || !isNonZeroPrice(pricing.surchargeTotal)) {
    return null
  }

  return formatSurchargePrice(pricing.surchargeTotal)
}

export const getDeliveryTotal = (pricing: DeliveryPricing) =>
  pricing.isDeliveryFree ? 'Free' : formatPrice(pricing.deliveryTotal)
